import { Box, SlideFade } from '@chakra-ui/react';
import { PageContainer } from '@/components/PageContainer';
import { Footer } from '@/components/Footer';
import { SiteNav } from '@/components/Navbar/SiteNav';
import { TeamDetailRoot } from '@/components/teamDetail';
import { useWc26Fixtures } from '@/hooks/useWc26Fixtures';
import { useWc26GameResults } from '@/hooks/useWc26GameResults';
import { TournamentStagePageContent } from '@/components/tournamentStage/TournamentStagePageContent';

export default function FixturesPage() {
  const fixtures = useWc26Fixtures();
  const gameResults = useWc26GameResults();

  return (
    <TeamDetailRoot>
      <SlideFade in>
        <PageContainer>
          <SiteNav />
          <Box as='main' width='full' pb={10}>
            <Box maxW='min(1220px, 100%)' mx='auto' px={{ base: 4, md: 8, xl: 12 }}>
              <TournamentStagePageContent variant='fixtures' fixtures={fixtures} gameResults={gameResults} />
            </Box>
          </Box>
          <Footer />
        </PageContainer>
      </SlideFade>
    </TeamDetailRoot>
  );
}
